import type { FC } from 'react'
import type { LinkType } from '../../frontend-types'
import { ButtonLink } from '../atoms/ButtonLink'
import type { CardArticleType } from '../atoms/CardArticle'
import { CardArticle } from '../atoms/CardArticle'
import type { CardFeatureProps } from '../atoms/CardFeature'
import { CardFeature } from '../atoms/CardFeature'
import { Grid } from '../atoms/Grid'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

type CardListBlockProps = {
	featuredCard?: CardFeatureProps
	cards: CardArticleType[]
	button?: LinkType
}

export const CardListBlock: FC<CardListBlockProps> = ({ featuredCard, cards, button }) => {
	const layoutClasses =
		'col-span-full tablet-p:col-span-4 layout-narrow:tablet-l:col-span-4 layout-wide:tablet-l:col-span-3'

	const blockTypes = ['component']
	if (button) blockTypes.push('cta')

	return (
		<ContentBlockWrapper blockTypes={blockTypes}>
			<div className="col-span-full">
				{featuredCard && (
					<div className="mb-2xl">
						<CardFeature {...featuredCard} />
					</div>
				)}
				<Grid className="gap-y-2xl layout-narrow:tablet-l:grid-cols-8 layout-wide:tablet-l:grid-cols-12">
					{cards.map((card) => (
						<div key={card.title} className={layoutClasses}>
							<CardArticle cardArticle={card} theme="primary" />
						</div>
					))}
				</Grid>
				{button && (
					<div className="mt-2xl">
						<ButtonLink {...button} icon={['fas', 'chevron-right']} />
					</div>
				)}
			</div>
		</ContentBlockWrapper>
	)
}
